// Simple inline spinner used for loading states. Falls back to "Loading…"
// text inside the same color scheme so screen readers get something useful.
export function Spinner({
  size = 16,
  label = "Loading",
}: {
  size?: number;
  label?: string;
}) {
  return (
    <span
      role="status"
      aria-label={label}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: `2px solid var(--border)`,
        borderTopColor: "var(--accent)",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
        verticalAlign: "middle",
      }}
    />
  );
}

// One-off keyframe injection so we don't drag in a CSS-in-JS dep just
// for a spinner. Idempotent — only runs once per page load.
if (
  typeof document !== "undefined" &&
  !document.getElementById("curator-spin-keyframes")
) {
  const style = document.createElement("style");
  style.id = "curator-spin-keyframes";
  style.textContent =
    "@keyframes spin { to { transform: rotate(360deg); } }";
  document.head.appendChild(style);
}
